import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const clientApiUrl = process.env.REACT_APP_CLIENT_API_URL;

const LocationAPI = {
	getOrganizationLocations: (organizationId: number) => {
		return axios
			.get(`${apiUrl}/organizations/${organizationId}/locations`)
			.then((response) => response.data as LocationDTO[]);
	},
	getOrganizationActiveLocations: ({
		organizationId,
	}: OrganizationActiveLocationsRequest) => {
		return axios
			.get(`${apiUrl}/organizations/${organizationId}/active-locations`)
			.then((response) => response.data as LocationDTO[]);
	},
	getDatasetLocations: (organizationId: number, datasetId: number) => {
		return axios
			.get(
				`${apiUrl}/organizations/${organizationId}/datasets/${datasetId}/locations`
			)
			.then((response) => response.data as LocationDTO[]);
	},
	getCourseForLocationRequest: (req: GetCoursesForLocationRequest) => {
		return axios
			.get(
				`${apiUrl}/organizations/${req.organizationId}/locations/${req.locationId}/get-courses`
			)
			.then((res) => res.data as CourseDTO[]);
	},
	getLocationNames: (req: LocationNamesRequest) => {
		return axios
			.get(
				`${apiUrl}/organizations/${req.organizationId}/locations/${req.locationId}/location-names`
			)
			.then((res) => res.data as string[]);
	},
	getSingleOrganizationLocation: (request: OrganizationLocationRequest) => {
		return axios
			.get(
				`${apiUrl}/organizations/${request.organizationId}/locations/${request.id}`
			)
			.then((response) => response.data as LocationDTO);
	},
	upsertSingleOrganizationLocation: (
		locationDetails: UpsertOrganizationLocationRequest
	) => {
		return axios
			.post(
				`${apiUrl}/organizations/${locationDetails.organizationId}/locations`,
				locationDetails
			)
			.then((response) => response.data as LocationDTO);
	},
	addLocationToDataset: (req: AddLocationToDatasetXrefLocationRequest) => {
		return axios
			.post(
				`${apiUrl}/organizations/${req.organizationId}/datasets/${req.datasetId}/locations/${req.locationId}`
			)
			.then((res) => res.data as boolean);
	},

	upsertLocationLogo: (logo: File) => {
		const data = new FormData();
		data.append("file", logo);

		return axios
			.post(`${apiUrl}/locations/logo-upload`, data)
			.then((response) => response.data as string);
	},

	removeLocationFromDataset: (
		req: RemoveLocationFromDatasetXrefLocationRequest
	) => {
		return axios
			.delete(
				`${apiUrl}/organizations/${req.organizationId}/datasets/${req.datasetId}/locations/${req.locationId}`
			)
			.then((res) => res.data as boolean);
	},

	// client site methods
	getClientSiteOrganizationLocations: (
		organizationId: number,
		datasetId: number
	) => {
		return axios
			.get(
				`${clientApiUrl}/organizations/${organizationId}/datasets/${datasetId}/locations`
			)
			.then((response) => response.data as LocationDTO[]);
	},
	getClientSiteDatasetLocations: (
		request: ClientSiteDatasetLocationsRequest
	) => {
		return axios
			.get(
				`${clientApiUrl}/organizations/${request.organizationId}/datasets/${request.datasetId}/locations`
			)
			.then((res) => res.data as LocationDTO[]);
	},
};

export default LocationAPI;
